import jQuery from 'jquery'; // Required for Slick import.
import '@accessible360/accessible-slick';

export const initRelatedProductGalleries = () => {
  const $galleries = $('.related-products__gallery');
  if ($galleries.length) {
    $galleries.each((i,el) => {
      const $gallery = $(el);
      const $containingTab = $gallery.closest('.tab-pane')
      const slickSettings = {
        autoplay: false,
        dots: true,
        infinite: false,
        rows: 0,
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 991,
            settings: {
              slidesToShow: 2,
            }
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 1,
            }
          },
        ]
      };

      $gallery.not('.slick-initialized').slick(slickSettings);

      if ($containingTab.length) {
        const tabId = $containingTab.attr('id');
        const $tabButton = $(`button[data-bs-target="#${tabId}"]`)
        $tabButton.on('click', (e) => {
          $gallery.slick('refresh');
        })
      }
    })
  }
}

(($) => {
  $(() => {
    initRelatedProductGalleries();
  });
})(jQuery);
